import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const BreakdownSheetSkeleton: React.FC = () => (
  <div className="space-y-3 rounded-md border p-3">
    {Array.from({ length: 4 }).map((_, i) => (
      <div key={i} className="flex items-center gap-3">
        <div className="flex-1 space-y-1">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
        <Skeleton className="h-4 w-24" />
      </div>
    ))}
  </div>
)
export default BreakdownSheetSkeleton
